/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Trainer_TitleInputs */

const en_for_whom_trainer_title = /** @type {(inputs: For_Whom_Trainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More sessions, fewer spreadsheets.`)
};

const pl_for_whom_trainer_title = /** @type {(inputs: For_Whom_Trainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Więcej treningów, mniej arkuszy.`)
};

/**
* | output |
* | --- |
* | "More sessions, fewer spreadsheets." |
*
* @param {For_Whom_Trainer_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_trainer_title = /** @type {((inputs?: For_Whom_Trainer_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Trainer_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_trainer_title(inputs)
	return en_for_whom_trainer_title(inputs)
});